import { useEffect, useState } from 'react'
import { HStack, Text, Button, Input, Field, Dialog, Portal, CloseButton } from '@chakra-ui/react';

function toDateInputValue(dateStr?: string) {
  if (!dateStr) return ''
  return dateStr.substring(0, 10)
}

export interface ContractEditTarget {
  type: 'business' | 'worksite-override' | 'standalone'
  label: string
  startDate?: string
  endDate?: string
  // business affiliation context
  businessId?: string
  // worksite override context
  worksiteId?: string
  isOverride?: boolean
  isExcluded?: boolean
  unionRepName?: string
  employerContactId?: string
  employerContactName?: string
}

export function EditContractModal({ target, onClose, onSave, isLoading }: {
  target: ContractEditTarget | null
  onClose: () => void
  onSave: (startDate?: string, endDate?: string) => void
  isLoading: boolean
}) {
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  useEffect(() => {
    if (target) {
      setStartDate(toDateInputValue(target.startDate))
      setEndDate(toDateInputValue(target.endDate))
    }
  }, [target])

  return (
    <Dialog.Root open={!!target} size='sm' onOpenChange={e => {
      if (!e.open) {
        onClose();
      }
    }}>
      <Portal>

        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header fontSize="md">Edit Contract Period</Dialog.Header>
            <Dialog.CloseTrigger asChild><CloseButton size="sm" /></Dialog.CloseTrigger>
            <Dialog.Body>
              <Text fontSize="xs" color="gray.500" mb={3}>{target?.label}</Text>
              <HStack gap={4}>
                <Field.Root>
                  <Field.Label fontSize="sm">Start</Field.Label>
                  <Input
                    size="sm"
                    type="date"
                    value={startDate}
                    onChange={e => setStartDate(e.target.value)}
                  />
                </Field.Root>
                <Field.Root>
                  <Field.Label fontSize="sm">End</Field.Label>
                  <Input
                    size="sm"
                    type="date"
                    value={endDate}
                    onChange={e => setEndDate(e.target.value)}
                  />
                </Field.Root>
              </HStack>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant="ghost" size="sm" mr={2} onClick={onClose}>Cancel</Button>
              <Button
                colorPalette="brand"
                size="sm"
                loading={isLoading}
                onClick={() => onSave(startDate || undefined, endDate || undefined)}
              >
                Save
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>

      </Portal>
    </Dialog.Root>
  );
}
